import {message, Select} from "antd";
import React, {useEffect, useState} from "react";
import ChuangShiOS from "chuangshi-os-website-component";
import Application from "../../common/Application";
import {useSelector} from "react-redux";


const SupplierSelect = (props)=>{
    const store = useSelector((store) => store);
    const [supplierOptions,setSupplierOptions] = useState([]);//{name:"WDM",label:"温德姆"},{name:"ZKT",label:"直客通"}

    useEffect(() => handleSupplierOptions(),
        //eslint-disable-next-line
        [store.main.userName]);

    const handleSupplierOptions = ()=>{
        ChuangShiOS.Util.request(props, {
            url:Application.host+"/windeal/supplier/select",
            data:{},
            success:(response)=>{
                setSupplierOptions(response.data.options)
            },
            error:(response)=>{
                message.error({content: response.message, duration: 1});
            },
            complete:(response)=>{
            }
        });
    }

    return (
        <Select className={props.className} style={props.style} placeholder="请选择供货渠道" value={props.value} allowClear disabled={props.disabled}
                    onChange={(v) => props.onChange(v)}>
        {supplierOptions.map((v)=>{return ( props.hideName&&props.hideName.indexOf(v.name)!==-1?'':<Select.Option  key={v.name}  value={v.name}>{v.label}</Select.Option>)})}
    </Select>
    )
}


SupplierSelect.propTypes = {};

SupplierSelect.defaultProps = {};

export default SupplierSelect;
